import Request from './request'

const CompanyContracts  = {
  getContractList(params, callback) {
    Request.get('company-contracts', params).then(callback).catch(this.bad_answer)
  },
}

export default CompanyContracts
